// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"122":"blue","406":"red","505":"theme","532":"styles"}[chunkId] + "." + {"122":"6179526508f41dcda18a","406":"e6b8ea9fdaad0b11f750","505":"3a736c9f553c6b471c31","532":"188aeafc85e396a54166"}[chunkId] + ".css";
};